import { COURSES_EVENTS } from '@/courses/values/courses-events.values';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';


@Component({})
export class UserPositionObserverMixin extends Vue {

  mounted() {
    this.$edEventBus.$on(COURSES_EVENTS.COURSE_SELECTED, this.$App.Store.updateUserPosition);
    this.$edEventBus.$on(COURSES_EVENTS.OBJECT_SELECTED, this.$App.Store.updateUserPosition);
    this.$edEventBus.$on(COURSES_EVENTS.SECTION_SELECTED, this.$App.Store.updateUserPosition);
  }

  beforeDestroy() {
    this.$edEventBus.$off(COURSES_EVENTS.COURSE_SELECTED, this.$App.Store.updateUserPosition);
    this.$edEventBus.$off(COURSES_EVENTS.OBJECT_SELECTED, this.$App.Store.updateUserPosition);
    this.$edEventBus.$off(COURSES_EVENTS.SECTION_SELECTED, this.$App.Store.updateUserPosition);
    this.$App.Store.cleanUserPosition();
  }

}
